/**
 * Ce qui se pose par-dessus le live, et ce que cela fait à la visio : une seule couche à la fois, et
 * une visio qui s'efface franchement derrière un volet.
 *
 *  - **La sortie passe devant** (Wajih, 20/10 : en quittant le live, une couche s'ouvrait par-dessus une
 *    autre) : la barre du live reste à portée pendant une conversation de Sam, et « Quitter le live »
 *    posait « Veux-tu vraiment quitter ? », puis la note, sur la feuille de Sam encore ouverte. Tant que
 *    la sortie est posée, le chat et Sam se retirent derrière elle, sans être démontés : annulée, la
 *    sortie les rend tels qu'ils étaient.
 *  - **La visio s'efface sous le voile des feuilles** (`scrim`, Wajih, 20/10 : « beaucoup plus fort »)
 *    dès qu'un volet s'ouvre par-dessus, le chat ou Sam, et quand le masteur envoie Sam à l'élève : la
 *    vidéo qui bouge ne tire plus l'œil loin de ce qui s'ouvre. Les autres feuilles (« Mes activités »,
 *    « Un problème ? », les appareils) posent déjà ce voile sur tout l'écran.
 */

/**
 * Le bandeau quand le masteur envoie Sam : les mots de Wajih (20/10), alignés sur le vocabulaire de
 * l'espace élève, où le tuteur est « ton masteur ».
 */
export const SAM_SENT_NOTICE = "Ton masteur n'est pas disponible, Sam s'occupe de toi en attendant."

export type UILiveLayers = {
    /** Le chat et la conversation de Sam se montrent : rien de la sortie n'est posé. */
    sheets: boolean
    /** La visio passe sous le voile. */
    stageVeil: boolean
}

export function liveLayers(args: {
    /** Le chat est ouvert. */
    chat: boolean
    /** Une conversation de Sam est ouverte. */
    checkpoint: boolean
    /** « Veux-tu vraiment quitter ? » ou la note sont posées. */
    leave: boolean
    /** Le masteur vient d'envoyer Sam à l'élève. */
    samSent: boolean
}): UILiveLayers {
    const { chat, checkpoint, leave, samSent } = args
    return {
        sheets: !leave,
        stageVeil: chat || checkpoint || samSent,
    }
}
